export const type = 'form.content';
